// @ts-nocheck
// PDF export for configurator: page 1 = maximized SVG preview, page 2 = debug/build guide.
(function () {
  const Preview = window.Cfg?.Preview;
  const Engine = window.Cfg?.Engine;

  // Inline logo SVG for PDF header.
  const LOGO_SVG = `<svg width="205" height="51" viewBox="0 0 205 51" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1312_217)">
<path d="M50.7192 13.9415C44.1291 20.5124 35.4903 23.7978 26.8516 23.7978V0H50.7192V13.9415Z" fill="#687A65"/>
<path d="M23.8677 13.9415C17.2775 20.5124 8.63877 23.7978 0 23.7978V0H23.8677V13.9415Z" fill="#687A65"/>
<path d="M50.7192 36.6288C44.1291 30.0579 35.4903 26.7725 26.8516 26.7725V50.5703H50.7192V36.6288Z" fill="#687A65"/>
<path d="M0 50.5703V26.7725L23.8411 38.6714V50.5703H0Z" fill="#687A65"/>
<path d="M67.652 14.044V21.9898H62.6133V0.00660706H72.82C78.3958 0.00660706 80.756 3.17965 80.756 6.91458C80.756 10.243 78.8665 12.3782 76.4101 13.2276V13.2904C76.6621 13.73 76.851 14.0143 77.1991 14.6423L81.3892 21.9898H75.5615L71.4675 14.4836C71.2454 14.1068 71.1824 14.044 70.6786 14.044H67.6553H67.652ZM67.652 9.96202H72.1869C74.4543 9.96202 75.6212 8.79857 75.6212 7.04018C75.6212 5.28179 74.4245 4.08859 72.1869 4.08859H67.652V9.96202Z" fill="#12281D"/>
<path d="M93.8572 20.1356C92.7864 21.4544 91.1157 22.3336 88.7555 22.3336C85.6692 22.3336 82.709 20.5752 82.709 17.2468C82.709 13.9184 85.4505 12.6624 89.7632 11.9716L93.5124 11.3734V11.1519C93.5124 9.39351 92.5345 8.70272 90.8339 8.70272C89.1334 8.70272 88.0295 9.51911 87.7477 11.0263H83.2758C83.8129 7.47647 86.9289 5.31153 91.056 5.31153C95.4649 5.31153 98.2362 7.04018 98.2064 11.6246L98.1766 18.5325C98.1766 19.068 98.2064 20.01 98.3025 21.9865H93.9235L93.8605 20.1323L93.8572 20.1356ZM89.982 18.9424C91.9047 18.9424 93.5091 17.812 93.5091 15.5512V14.4505C89.193 14.986 87.3367 15.4553 87.3367 17.0253C87.3367 18.2813 88.4704 18.9424 89.982 18.9424Z" fill="#12281D"/>
<path d="M106.675 21.9898H101.889V5.72138H106.52V7.63842C107.527 6.16098 109.261 5.34458 111.369 5.34458C113.292 5.34458 115.182 6.13123 116.282 7.98217C117.353 6.25353 119.305 5.34458 121.606 5.34458C124.818 5.34458 127.623 7.10297 127.623 11.6874V21.9898H122.836V12.5699C122.836 10.4644 121.669 9.42987 120.094 9.42987C118.52 9.42987 117.164 10.6231 117.164 13.1351V21.9898H112.377V12.5699C112.377 10.4644 111.21 9.42987 109.636 9.42987C108.061 9.42987 106.675 10.5933 106.675 13.1351V21.9898Z" fill="#12281D"/>
<path d="M136.06 19.9472V27.9558H131.273V5.72138H135.934V7.82682C136.879 6.25683 138.55 5.34458 140.847 5.34458C144.911 5.34458 148.375 8.23337 148.375 13.73C148.375 19.2266 144.878 22.3336 140.817 22.3336C138.613 22.3336 137.038 21.4544 136.06 19.9472ZM143.496 13.73C143.496 10.7454 141.858 9.17537 139.746 9.17537C137.635 9.17537 135.967 10.871 135.967 13.73C135.967 16.7774 137.668 18.5028 139.746 18.5028C141.825 18.5028 143.496 16.7741 143.496 13.73Z" fill="#12281D"/>
<path d="M159.022 22.3666C154.298 22.3666 150.33 19.1308 150.33 13.7631C150.33 8.39533 154.424 5.31483 158.929 5.31483C163.434 5.31483 167.369 8.39202 167.369 14.1068V15.0818H155.117C155.369 17.4385 157.04 18.8498 159.181 18.8498C160.567 18.8498 161.952 18.3772 162.615 17.0914H167.213C166.205 20.7338 162.615 22.3666 159.025 22.3666H159.022ZM155.084 12.0642H162.549C162.393 10.0843 160.911 8.79857 158.863 8.79857C156.814 8.79857 155.336 9.99176 155.084 12.0642Z" fill="#12281D"/>
<path d="M169.256 16.8369H173.698C173.95 18.3441 175.243 19.068 177.006 19.068C178.392 19.068 179.622 18.5656 179.622 17.4352C179.622 16.4304 178.71 15.9908 176.661 15.6437L174.961 15.3297C171.623 14.7315 169.544 13.2574 169.544 10.6495C169.544 7.32112 172.63 5.27848 176.569 5.27848C180.507 5.27848 183.404 7.16247 183.845 10.4909H179.466C179.151 9.26461 178.08 8.57381 176.473 8.57381C175.087 8.57381 174.046 9.20181 174.046 10.1769C174.046 11.0891 174.865 11.4329 176.628 11.7469L178.299 12.0278C182.015 12.6888 184.22 14.1332 184.22 16.9592C184.22 20.5388 180.818 22.36 176.913 22.36C173.008 22.36 169.733 20.6314 169.259 16.8336L169.256 16.8369Z" fill="#12281D"/>
<path d="M75.6513 49.083C73.8877 50.2761 71.8723 51 69.2568 51C64.7219 51 61.4766 48.5508 61.4766 44.5944C61.4766 41.7354 63.1141 39.7886 65.7595 38.4401C64.5926 37.1213 63.807 35.7694 63.807 33.9482C63.807 30.5868 66.7374 28.2004 70.5164 28.2004C74.2955 28.2004 77.1298 30.3984 77.1298 33.8226C77.1298 36.3346 75.522 38.093 72.6248 39.349L75.9629 42.9286C76.6557 41.8907 77.0668 40.6975 77.2557 39.2234H81.6646C81.4127 41.894 80.4978 44.3102 78.9232 46.1314L83.0801 50.5901V50.6199H77.0966L75.648 49.0796L75.6513 49.083ZM69.6678 47.199C70.8645 47.199 71.9982 46.8519 72.9761 46.1611L68.3783 41.1999C66.9595 41.9535 66.2667 42.9914 66.2667 44.2474C66.2667 46.0388 67.8413 47.199 69.6678 47.199ZM70.0126 36.837C71.9352 36.1132 72.817 35.1712 72.817 33.9482C72.817 32.6592 71.8093 31.78 70.4866 31.78C69.1639 31.78 68.123 32.722 68.123 33.978C68.123 35.0158 68.8789 35.8322 70.0126 36.837Z" fill="#12281D"/>
<path d="M85.5098 28.64H95.5574C100.692 28.64 103.115 31.0594 103.115 34.4804C103.115 36.9295 101.73 38.5623 99.9033 39.1275V39.1903C102.045 39.8514 103.59 41.7023 103.59 44.4358C103.59 48.2666 100.659 50.6232 95.3054 50.6232H85.5098V28.64ZM90.4855 32.408V37.5278H94.8944C96.9729 37.5278 98.0767 36.6155 98.0767 34.9828C98.0767 33.35 96.943 32.408 94.8944 32.408H90.4855ZM90.4855 41.1702V46.8552H94.8016C97.195 46.8552 98.4878 45.8174 98.4878 44.0292C98.4878 42.2411 97.195 41.1702 94.8347 41.1702H90.4888H90.4855Z" fill="#12281D"/>
<path d="M117.064 48.769C115.993 50.0877 114.323 50.9669 111.962 50.9669C108.876 50.9669 105.916 49.2086 105.916 45.8802C105.916 42.5518 108.657 41.2958 112.97 40.605L116.719 40.0067V39.7853C116.719 38.0269 115.742 37.3361 114.041 37.3361C112.34 37.3361 111.237 38.1525 110.955 39.6597H106.483C107.02 36.1098 110.136 33.9449 114.263 33.9449C118.672 33.9449 121.443 35.6736 121.413 40.2579L121.384 47.1659C121.384 47.7014 121.413 48.6434 121.51 50.6199H117.13L117.068 48.7656L117.064 48.769ZM113.189 47.5758C115.112 47.5758 116.716 46.4454 116.716 44.1846V43.0839C112.4 43.6194 110.544 44.0887 110.544 45.6587C110.544 46.9147 111.677 47.5758 113.189 47.5758Z" fill="#12281D"/>
<path d="M125.094 28.012H129.881V50.6232H125.094V28.012Z" fill="#12281D"/>
<path d="M132.777 42.3964C132.777 37.3097 136.745 33.9482 141.439 33.9482C145.692 33.9482 149.031 36.4602 149.534 40.3538H144.811C144.433 38.8135 143.077 37.8418 141.439 37.8418C139.235 37.8418 137.69 39.696 137.69 42.3964C137.69 45.0968 139.265 47.1064 141.439 47.1064C143.047 47.1064 144.337 46.1942 144.777 44.5614H149.534C148.905 48.5806 145.533 51 141.409 51C136.623 51 132.781 47.6386 132.781 42.3964H132.777Z" fill="#12281D"/>
<path d="M151.299 42.3964C151.299 37.2138 155.3 33.9482 160.15 33.9482C165 33.9482 169.001 37.1841 169.001 42.3964C169.001 47.6088 165.063 51 160.15 51C155.237 51 151.299 47.6716 151.299 42.3964ZM164.088 42.3964C164.088 39.663 162.48 37.8418 160.15 37.8418C157.819 37.8418 156.212 39.663 156.212 42.3964C156.212 45.1299 157.819 47.1064 160.15 47.1064C162.48 47.1064 164.088 45.2852 164.088 42.3964Z" fill="#12281D"/>
<path d="M176.654 50.6232H171.867V34.3548H176.498V36.3346C177.539 34.8274 179.332 33.978 181.444 33.978C185.004 33.978 187.398 36.1132 187.398 40.4794V50.6232H182.611V41.3288C182.611 39.2564 181.54 38.0633 179.743 38.0633C178.073 38.0633 176.657 39.2895 176.657 41.9568V50.6232H176.654Z" fill="#12281D"/>
<path d="M190.041 45.4736H194.483C194.735 46.9808 196.028 47.7047 197.791 47.7047C199.177 47.7047 200.407 47.2023 200.407 46.0719C200.407 45.0671 199.495 44.6275 197.447 44.2804L195.746 43.9664C192.408 43.3682 190.329 41.894 190.329 39.2862C190.329 35.9578 193.416 33.9152 197.354 33.9152C201.292 33.9152 204.189 35.7992 204.63 39.1275H200.251C199.936 37.9013 198.865 37.2105 197.258 37.2105C195.872 37.2105 194.831 37.8385 194.831 38.8135C194.831 39.7258 195.65 40.0695 197.413 40.3835L199.084 40.6645C202.8 41.3255 205.005 42.7699 205.005 45.5959C205.005 49.1755 201.604 50.9967 197.699 50.9967C193.794 50.9967 190.518 49.268 190.044 45.4703L190.041 45.4736Z" fill="#12281D"/>
</g>
<defs>
<clipPath id="clip0_1312_217">
<rect width="205" height="51" fill="white"/>
</clipPath>
</defs>
</svg>`;

  function formatMeasure(value, decimals = 3) {
    if (!Number.isFinite(value)) return "—";
    const rounded = decimals >= 0 ? Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) : value;
    let s = String(rounded);
    if (s.includes(".")) {
      s = s.replace(/0+$/, "").replace(/\.$/, "");
    }
    return s + '"';
  }

  /**
   * Scale down decorative strokes, text, and symbols for PDF. Skips geometry lines (offset bands, etc.)
   * whose stroke-width represents actual dimensions.
   */
  function scaleSvgForPdf(svgEl, factor = 0.55) {
    const walk = (el) => {
      const stroke = (el.getAttribute("stroke") || "").toLowerCase();
      const strokeWidth = el.getAttribute("stroke-width");
      // Skip offset lines (grey bands): stroke #BBAF96 has geometric stroke-width
      const isOffsetLine = /^#bbaf96|rgb\s*\(\s*187\s*,\s*175\s*,\s*150\s*\)/.test(stroke);
      if (strokeWidth && !isOffsetLine) {
        const v = parseFloat(strokeWidth);
        if (Number.isFinite(v)) el.setAttribute("stroke-width", String(v * factor));
      }
      const dashArray = el.getAttribute("stroke-dasharray");
      if (dashArray && !isOffsetLine) {
        const parts = dashArray.split(/[\s,]+/).map((s) => parseFloat(s));
        if (parts.every(Number.isFinite)) {
          el.setAttribute("stroke-dasharray", parts.map((p) => p * factor).join(" "));
        }
      }
      const fontSize = el.getAttribute("font-size");
      if (fontSize) {
        const v = parseFloat(fontSize);
        if (Number.isFinite(v)) el.setAttribute("font-size", String(v * factor));
      }
      if (el.tagName === "rect") {
        const w = el.getAttribute("width");
        const h = el.getAttribute("height");
        const x = el.getAttribute("x");
        const y = el.getAttribute("y");
        if (w && h) {
          const vw = parseFloat(w);
          const vh = parseFloat(h);
          if (Number.isFinite(vw) && Number.isFinite(vh)) {
            const cx = (x ? parseFloat(x) : 0) + vw / 2;
            const cy = (y ? parseFloat(y) : 0) + vh / 2;
            const nw = vw * factor;
            const nh = vh * factor;
            el.setAttribute("width", String(nw));
            el.setAttribute("height", String(nh));
            el.setAttribute("x", String(cx - nw / 2));
            el.setAttribute("y", String(cy - nh / 2));
          }
        }
      }
      for (const child of el.children) walk(child);
    };
    walk(svgEl);
  }

  function svgToPngDataUrl(svgEl, widthPx, heightPx) {
    return new Promise((resolve, reject) => {
      const serializer = new XMLSerializer();
      const svgStr = serializer.serializeToString(svgEl);
      const blob = new Blob([svgStr], { type: "image/svg+xml;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const img = new Image();
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = widthPx;
          canvas.height = heightPx;
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            reject(new Error("Canvas 2d not available"));
            return;
          }
          ctx.drawImage(img, 0, 0, widthPx, heightPx);
          const dataUrl = canvas.toDataURL("image/png");
          resolve(dataUrl);
        } finally {
          URL.revokeObjectURL(url);
        }
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("Failed to load SVG as image"));
      };
      img.src = url;
    });
  }

  /**
   * Generate a 2-page PDF: page 1 = maximized SVG preview, page 2 = build guide with gaps, panel sizes, config link.
   * @param {object} options
   * @param {SVGSVGElement} options.svg - The preview SVG element
   * @param {object} options.plan - Normalized plan from Engine.normalizePlan
   * @param {object} [options.layout] - Layout summary from Engine.computeRecommendedBom
   * @param {string} options.configUrl - Full URL with query params to restore this config
   * @param {string} [options.isFr] - Use French labels
   * @returns {Promise<Blob>}
   */
  async function generateConfigPdf({ svg, plan, layout, configUrl, isFr = true }) {
    const JsPDF = window.jspdf?.jsPDF || window.jsPDF;
    if (!JsPDF) throw new Error("jsPDF not loaded");

    const PAGE_W = 595.28;
    const PAGE_H = 841.89;
    const MARGIN = 40;

    // Clone SVG and set export dimensions from viewBox
    const vb = svg.getAttribute("viewBox");
    if (!vb) throw new Error("SVG has no viewBox");
    const [vbX, vbY, vbW, vbH] = vb.split(/\s+/).map(Number);
    const canvasW = Math.max(1, vbW || 100);
    const canvasH = Math.max(1, vbH || 100);

    // Portrait if canvas taller than wide, else landscape
    const isPortrait = canvasH >= canvasW;
    const doc = new JsPDF(isPortrait ? "p" : "l", "pt", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const contentW = pageW - MARGIN * 2;
    const contentH = pageH - MARGIN * 2;

    // Scale to fill
    const scaleX = contentW / canvasW;
    const scaleY = contentH / canvasH;
    const scale = Math.min(scaleX, scaleY);
    const imgW = canvasW * scale;
    const imgH = canvasH * scale;
    const offsetX = MARGIN + (contentW - imgW) / 2;
    const offsetY = MARGIN + (contentH - imgH) / 2;

    // Export at ~2 px/pt for sharp PDF display (144 DPI equivalent)
    const exportScale = Math.max(4, Math.round(2 * scale));
    const exportW = Math.round(canvasW * exportScale);
    const exportH = Math.round(canvasH * exportScale);

    // Render logo as PNG once so it can be reused on both pages.
    let logoData = null;
    try {
      const logoDoc = new DOMParser().parseFromString(LOGO_SVG, "image/svg+xml");
      const logoEl = logoDoc.documentElement;
      const logoExportW = 410;
      const logoExportH = 102;
      logoData = await svgToPngDataUrl(logoEl, logoExportW, logoExportH);
    } catch (e) {
      console.error("Failed to render PDF logo", e);
    }

    // Add logo in the top-left header on page 1.
    const logoDisplayW = 140;
    const logoDisplayH = (51 / 205) * logoDisplayW;
    const logoX = MARGIN;
    const logoY = 40;
    if (logoData) {
      doc.addImage(logoData, "PNG", logoX, logoY, logoDisplayW, logoDisplayH);
    }

    const clone = svg.cloneNode(true);
    clone.removeAttribute("data-rb-preview-svg");
    clone.setAttribute("width", String(exportW));
    clone.setAttribute("height", String(exportH));
    const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    rect.setAttribute("x", String(vbX || 0));
    rect.setAttribute("y", String(vbY || 0));
    rect.setAttribute("width", String(vbW || 100));
    rect.setAttribute("height", String(vbH || 100));
    rect.setAttribute("fill", "#fff");
    clone.insertBefore(rect, clone.firstChild);

    scaleSvgForPdf(clone);

    const imgData = await svgToPngDataUrl(clone, exportW, exportH);
    doc.addImage(imgData, "PNG", offsetX, offsetY, imgW, imgH);

    // Page 2: build guide
    doc.addPage();
    const t = (key, def) => (isFr ? (key === "title" ? "Guide de construction" : key === "side" ? "Côté" : key === "seg" ? "Segment" : key === "gaps" ? "Écarts aux extrémités" : key === "between" ? "Entre panneaux" : key === "panels" ? "Panneaux" : key === "corner" ? "Distance du bord" : key === "raw" ? "Longueur brute" : key === "eff" ? "Longueur effective" : key === "opening" ? "Ouverture" : def) : (key === "title" ? "Build Guide" : key === "side" ? "Side" : key === "seg" ? "Segment" : key === "gaps" ? "End gaps" : key === "between" ? "Between panels" : key === "panels" ? "Panels" : key === "corner" ? "Edge distance" : key === "raw" ? "Raw length" : key === "eff" ? "Effective length" : key === "opening" ? "Opening" : def));

    let y = MARGIN;
    const lineH = 14;
    const smallH = 11;

    // Logo on page 2 as well, and push content down so it doesn't overlap.
    if (logoData) {
      doc.addImage(logoData, "PNG", logoX, logoY, logoDisplayW, logoDisplayH);
      y = logoY + logoDisplayH + 32;
    }

    doc.setFontSize(18);
    doc.setFont(undefined, "bold");
    doc.text(t("title"), MARGIN, y);
    y += lineH + 4;

    doc.setFontSize(10);
    doc.setFont(undefined, "normal");

    const edgeDistanceIn = plan?.edgeDistanceIn;
    if (Number.isFinite(edgeDistanceIn) && edgeDistanceIn > 0) {
      doc.setFont(undefined, "bold");
      doc.text(`${t("corner")}: ${formatMeasure(edgeDistanceIn)}`, MARGIN, y);
      y += lineH;
      doc.setFont(undefined, "normal");
    }

    const sides = layout?.sides || [];
    const sideSegments = plan?.sideSegments || {};
    const openingBySide = plan?.openingBySide || {};

    for (const summary of sides) {
      const label = summary.label || "";
      const segData = sideSegments[label];
      if (!segData) continue;

      y += 4;
      doc.setFont(undefined, "bold");
      doc.text(`${t("side")} ${label}`, MARGIN, y);
      y += lineH;

      if (Number.isFinite(segData.rawLengthIn)) {
        doc.setFont(undefined, "normal");
        doc.setFontSize(9);
        doc.text(`  ${t("raw")}: ${formatMeasure(segData.rawLengthIn)}`, MARGIN, y);
        y += smallH;
      }
      if (Number.isFinite(segData.effectiveLengthIn)) {
        doc.text(`  ${t("eff")}: ${formatMeasure(segData.effectiveLengthIn)}`, MARGIN, y);
        y += smallH;
      }
      doc.setFontSize(10);

      const segments = Array.isArray(summary.segments) && summary.segments.length ? summary.segments : [summary];
      const showSegmentHeaders = segments.length > 1;

      for (const seg of segments) {
        const segLabel = seg.label || label;
        const effIn = seg.effectiveLengthIn;
        const endGapStart = Number(seg.endGapStart) || 0;
        const endGapEnd = Number(seg.endGapEnd) || 0;
        const gapIn = Number(seg.gapIn) || 0;
        const panels = Array.isArray(seg.panels) ? seg.panels : [];
        const indent = showSegmentHeaders ? "    " : "  ";

        if (showSegmentHeaders) {
          doc.setFont(undefined, "bold");
          // Small margin above each segment header (~3px)
          y += 3;
          doc.text(`  ${t("seg")} ${segLabel}:`, MARGIN, y);
          y += lineH;
          doc.setFont(undefined, "normal");
        }

        if (showSegmentHeaders && Number.isFinite(effIn)) {
          doc.text(`${indent}${t("eff")}: ${formatMeasure(effIn)}`, MARGIN, y);
          y += smallH;
        }
        if (endGapStart > 0 || endGapEnd > 0) {
          doc.text(`${indent}${t("gaps")}: ${formatMeasure(endGapStart)} / ${formatMeasure(endGapEnd)}`, MARGIN, y);
          y += smallH;
        }
        if (gapIn > 0 && panels.length > 1) {
          doc.text(`${indent}${t("between")}: ${formatMeasure(gapIn)}`, MARGIN, y);
          y += smallH;
        }
        if (panels.length > 0) {
          const lengths = panels.map((p) => formatMeasure(Number(p?.lengthIn ?? p)));
          doc.text(`${indent}${t("panels")}: ${lengths.join(", ")}`, MARGIN, y);
          y += smallH;
        }

        const o = openingBySide[label];
        if (o && String(segLabel).startsWith("X")) {
          const x1 = o.x1In ?? o.x1;
          if (Number.isFinite(x1)) {
            doc.text(`${indent}${t("opening")} X${o.index || 1}: ${formatMeasure(x1)}`, MARGIN, y);
            y += smallH;
          }
        }
      }
      y += 4;
    }

    // Vertical spacing before the project-link button.
    y += 34;

    // Clickable button-style link back to the configurator.
    const buttonLabel = isFr ? "Lien vers mon projet" : "Link to my project";
    const url = configUrl || "";
    if (url) {
      // Typography: similar to .btn-default (1rem text, generous padding).
      doc.setFontSize(10);
      doc.setFont(undefined, "normal");
      const paddingX = 25;
      const paddingY = 12;
      const textWidth = doc.getTextWidth(buttonLabel);
      const btnHeight = 2 * paddingY + 4;
      const btnWidth = textWidth + 2 * paddingX;
      const btnX = MARGIN;
      const btnY = y - btnHeight + 6;
      // Button background
      // Mimic .btn-default styles (green pill button with white text).
      doc.setFillColor(104, 122, 101); // #687A65 background
      doc.setDrawColor(104, 122, 101);
      doc.roundedRect(btnX, btnY, btnWidth, btnHeight, 5, 5, "FD");
      // Link text
      const textX = btnX + (btnWidth - textWidth) / 2;
      const textY = btnY + btnHeight / 2 + 4;
      doc.setTextColor(255, 255, 255);
      doc.textWithLink(buttonLabel, textX, textY, { url });
      doc.setTextColor(0, 0, 0);
    }

    return doc.output("blob");
  }

  window.Cfg = window.Cfg || {};
  window.Cfg.Pdf = { generateConfigPdf };
})();
